<template>
  <v-list dense>
    <v-list-item
      v-for="(item, index) in localItems"
      :key="item.id"
    >
      <v-list-item-content>
        <v-list-item-title>
          {{ index + 1 }}. {{ item.text }} / {{ item.textEng }}
        </v-list-item-title>
      </v-list-item-content>

      <v-list-item-action>
        <v-row>
            <v-col>
                <v-btn
                    icon
                    @click="moveUp(index)"
                    dark
                    :disabled="index === 0"
                    >
                    <v-icon>mdi-chevron-up</v-icon>
                </v-btn>
            </v-col>
            <v-col>
                 <v-btn
                    icon
                    @click="moveDown(index)"
                    dark
                    :disabled="index === localItems.length - 1"
                    >
                    <v-icon>mdi-chevron-down</v-icon>
                </v-btn>
            </v-col>
        </v-row>
      </v-list-item-action>
    </v-list-item>

    <v-divider />

    <v-card-actions class="justify-end">
      <v-btn color="primary" @click="save">
        บันทึก
      </v-btn>
      <v-btn text @click="$emit('close')">
        ปิด
      </v-btn>
    </v-card-actions>
  </v-list>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      localItems: JSON.parse(JSON.stringify(this.items))
    }
  },
  watch: {
    items (val) {
      this.localItems = JSON.parse(JSON.stringify(val))
    }
  },
  methods: {
    moveUp (index) {
      const temp = this.localItems[index]
      this.$set(this.localItems, index, this.localItems[index - 1])
      this.$set(this.localItems, index - 1, temp)
    },
    moveDown (index) {
      const temp = this.localItems[index]
      this.$set(this.localItems, index, this.localItems[index + 1])
      this.$set(this.localItems, index + 1, temp)
    },
    save () {
      this.$emit('save', this.localItems)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Master/CustomFieldSort.vue